import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

/**
 * Authenticated route that optionally requires a capability (resource+action).
 *
 * Used for VIEW-only pages so a view-only tier (e.g. FPA_USER) can reach them,
 * while create/edit routes stay on StaffRoute. The capability check mirrors the
 * backend permission, so anyone with the read/list grant (staff and FPA_USER)
 * gets in; everyone else is bounced to the dashboard.
 */
const CapabilityRoute = ({ children, resource, action }) => {
  const { isAuthenticated, can, isLoading } = useAuth();

  if (isLoading) {
    return <div>Loading...</div>;
  }
  if (!isAuthenticated) {
    return <Navigate to="/auth/login" replace />;
  }
  if (resource && action && !can(resource, action)) {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
};

export default CapabilityRoute;
